import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getFileArrayBuffer ({ state }, downloadUrl) {
      return (await Vue.http.get(downloadUrl, {
        responseType: 'arraybuffer',
        withCredentials: false
      })).data
    },
    async getFile ({ state }, fileId) {
      try {
        let downloadUrl = (await Vue.http.get(this.state.baseUrl + '/viewFile/' + fileId)).data

        return (await Vue.http.get(downloadUrl, {
          responseType: 'arraybuffer',
          withCredentials: false
        })).data
      }
      catch (e) {
        console.log(e)
        throw new Error(e)
      }
    },
    async getFiles ({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/patientfiles/_filter?pageSize=' + options.pageSize + '&pageNumber=' + options.pageNumber, options.query)).data
      } catch (e) {
        console.log(e)
      }
    },
    async uploadFile ({ state }, file) {
      try {
        //get presigned url from s3/minio
        let res = (await Vue.http.get(this.state.baseUrl + '/uploadurl/' + file.name)).data
        //upload file to s3/minio
        let res2 = (await Vue.http.put(res.url, file.data, {
          headers: { 'Content-Type': file.type == 'prescription' ? 'application/pdf' : file.type }
        })).data

        delete file.data
        file.fileId = res.fileId
        //create file doc in careportal
        let response = (await Vue.http.post(this.state.baseUrl + '/patientfiles', file)).data
        return response
      } catch (e) {
        throw e
      }
    },
    async uploadProfileImage({ state }, file) {
      try {
        //get presigned url from s3/minio
        let res = (await Vue.http.get(this.state.baseUrl + '/uploadurl/' + file.name)).data
        //upload file to s3/minio
        let res2 = (await Vue.http.put(res.url, file.data, {
          headers: { 'Content-Type': file.type }
        })).data
        file.fileId = res.fileId
        return file
      } catch (e) {
        return e
      }
    },
    async uploadFileToMinio ({ state }, file) {
      let formData = new FormData();
      formData.append('file', new Blob([file.data], { type: file.mediaType }), 'file1')

      return (await Vue.http.post(this.state.baseUrl + '/file/upload', formData)).data
    },
    async deleteFile ({ state }, fileToDelete) {
      try {
        let response = (await Vue.http.delete(this.state.baseUrl + '/file/' + fileToDelete.fileId)).data
        let file = (await Vue.http.delete(this.state.baseUrl + '/patientfiles/' + fileToDelete._id)).data
        return file
      } catch (e) {
        console.log(e)
        return e
      }
    },
    async deleteFileFromMinio ({ state }, fileToDelete) {
      try {
        let response = (await Vue.http.delete(this.state.baseUrl + '/file/' + fileToDelete.fileId)).data
        return response
      } catch (e) {
        console.log(e)
        return e
      }
    },
    async getPresignedUrl ({ state }, fileName) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/uploadurl/' + fileName)).data
      } catch (e) {
        throw e
      }
    },
    async saveFileToMinio ({ }, data) {
      try {
        return (await Vue.http.put(data.url, data.file, {
          headers: { 'Content-Type': undefined }
        })).data
      } catch (e) {
        throw e
      }
    },
    async savePatientFile ({ state }, file) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/patientfiles', file)).data || null
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getFileAsDataUrl ({ state }, fileId) {
      let fileType = fileId.substring(fileId.length - 3)
      if (fileType == 'svg') {
        fileType = fileType + '+xml'
      }
      let response = (await Vue.http.get(this.state.baseUrl + '/download/' + fileId, {
        responseType: 'arraybuffer'
      })).data

      var uInt8Array = new Uint8Array(response);
      var i = uInt8Array.length;
      var biStr = new Array(i);
      while (i--) {
        biStr[i] = String.fromCharCode(uInt8Array[i]);
      }
      var data = biStr.join('');
      var base64 = window.btoa(data);
      return 'data:image/' + fileType + ';base64,' + base64;
    },
    async getFileUrl ({ state }, fileId) {
      let downloadUrl = (await Vue.http.get(this.state.baseUrl + '/viewFile/' + fileId)).data
      return downloadUrl
    },
    async getPublicFileUrl ({ state }, urlPath) {
      let downloadUrl = (await Vue.http.get(this.state.baseUrl + urlPath)).data
      return downloadUrl
    },
    async getBrandLogo ({ state }, tenantName) {
      let tenant = 'default'
      if (tenantName != '') {
        tenant = tenantName
      }
      try {
        return (await Vue.http.get(this.state.baseUrl + '/brandlogourl/' + tenant)).data
      } catch (error) {
        console.log(error)
      }
    },
    async getAppBackground ({ state, commit }, tenantName) {
      let tenant = 'default'
      if (tenantName != '') {
        tenant = tenantName
      }
      try {
        let appBgUrl = (await Vue.http.get(this.state.baseUrl + '/appBackgroundUrl/' + tenant)).data
        commit('setState', {
          stateName: 'appBackgroundUrl',
          stateValue: appBgUrl
        })
        return appBgUrl
      } catch (error) {
        console.log(error)
      }
    },
    async getBrandLogoMini ({ state, commit }, tenantName) {
      let tenant = 'default'
      if (tenantName != '') {
        tenant = tenantName
      }
      try {
        let img = (await Vue.http.get(this.state.baseUrl + '/brandLogoMiniUrl/' + tenant)).data
        commit('setState', {
          stateName: 'brandLogoMini',
          stateValue: img
        })
        return img
      } catch (error) {
        console.log(error)
      }
    },
    async uploadChatFile ({ state }, fileDetails) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/patientfiles', fileDetails, {
          headers: {
            Authorization: `Bearer ${this.state.appointment._id}`
          }
        })).data
      } catch (e) {
        console.log(e)
      }
    },
  }
}
